"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deal_info_types_1 = require("./deal-info-types");
var currencies_1 = require("./currencies");
exports.getDefaultVideoDealInfo = function (currency) {
    if (currency === void 0) { currency = currencies_1.DEFAULT_CURRENCY; }
    return [
        {
            type: deal_info_types_1.DEAL_INFO_TYPES.RENT,
            enabled: false,
            price: currencies_1.CURRENCIES[currency].rent.default,
            period: 72,
        },
        {
            type: deal_info_types_1.DEAL_INFO_TYPES.SALE,
            enabled: false,
            price: currencies_1.CURRENCIES[currency].sale.default,
        },
    ];
};
exports.FREE_VIDEO_DEAL_INFO = [
    {
        type: deal_info_types_1.DEAL_INFO_TYPES.RENT,
        price: 0.01,
        enabled: false,
        period: 24,
    },
    {
        type: deal_info_types_1.DEAL_INFO_TYPES.SALE,
        price: 0.01,
        enabled: false,
        period: 0,
    },
];
//# sourceMappingURL=video-deal-info.js.map